module.exports = __webpack_public_path__ + "img/Cavern.ea377534.jpg";